import { Button, Modal, Table, Tooltip, Typography } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { IntegrationExecution } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { ExecutionRecordsPage } from './execution-records-page';
import { WarningOutlined } from '@ant-design/icons';

export function RecordHistoryPage(props: { recordId?: string, integrationType?: string}) {
  const [loading, setLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState<any[]>();
  const [records, setRecords] = useState<any[]>();
  const [recordsModalOpen, setRecordsModalOpen] = useState<IntegrationExecution>();

  const { Text } = Typography;

  const openRecordsModal = (integrationExecution: IntegrationExecution) => {
    setRecordsModalOpen(integrationExecution);
  };

  const closeRecordsModal = () => {
    setRecordsModalOpen(undefined);
  };

  const loadRecords = useCallback(() => {
    setLoading(true);

    apiClient
      .get(`integrations/records/${props.recordId}/history/${props.integrationType}`)
      .then(response => {
        const responseData = response.data as any[];

        if (!responseData.length) {
          return;
        }

        const responseRecords = responseData.map(r => {
          return { key: r.referenceId, integrationExecution: r.integrationExecution, ...JSON.parse(r.record) };
        });

        setRecords(responseRecords);

        const columns: any[] = [
          {
            title: 'Aktarım',
            key: 'integrationExecution',
            dataIndex: 'integrationExecution',
            render: (execution: IntegrationExecution) => (
              <Button type="link" style={{ paddingLeft: 0, paddingRight: 0 }} onClick={() => openRecordsModal(execution)}>
                {moment(execution.createdAt).format('DD.MM.yyyy HH:mm:ss')}
              </Button>
            ),
          },
        ];
        const columnNames = Object.getOwnPropertyNames(responseRecords[0]);
        for (let i = 2; i < columnNames.length; i++) {
          const column = {
            title: columnNames[i],
            dataIndex: columnNames[i],
            key: columnNames[i],
            render: (value: any) => value?.toString(),
          };
          columns.push(column);
        }
        

        columns.splice(1, 0, {
          title: '',
          dataIndex: 'integrationExecution',
          key: 'executionError',
          render: (execution: IntegrationExecution) => {
            return execution.hasError ? (
              <Tooltip title="Aktarım hatası mevcut">
                <Text type="danger">
                  <WarningOutlined />
                </Text>
              </Tooltip>
            ): null;
          },
        });

        const recordExportIdColumnIndex = columns.findIndex(c => c.dataIndex === '__record_export_id');
        if (recordExportIdColumnIndex > -1) {
          const recordExportIdColumn = columns.splice(recordExportIdColumnIndex, 1);
          recordExportIdColumn[0].title= 'Aktarım ID';
          columns.push(recordExportIdColumn[0]);
        }

        setTableColumns(columns);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.recordId]);

  useEffect(() => {
    loadRecords();
  }, [loadRecords]);

  if (!tableColumns) {
    return null;
  }

  return (
    <>
      <Table columns={tableColumns} dataSource={records} loading={loading} scroll={{ x: '100%' }} pagination={false} />
      <Modal
        title="Aktarım kayıtları"
        visible={!!recordsModalOpen}
        footer={null}
        onCancel={closeRecordsModal}
        destroyOnClose={true}
        width={'90%'}
      >
        <ExecutionRecordsPage integrationExecution={recordsModalOpen} />
      </Modal>
    </>
  );
}
